import GuidanceRegistry from '../guidance-registry.js';
import {guidanceUtils} from "../guidance-utils.js";
import {confetti} from "../../framework/utils/confetti-animation.js";

GuidanceRegistry.register({
    type: "action-item-ewf-plan-admin-done-cobra",
    prompt: 'Congratulations, your work here is done! If you need to contact your representative, the contact information is below.',
    beforeLoad: async (component, guidanceItem) => {
        await guidanceUtils.showPaDoneConfetti(guidanceItem, false);
    },
    openAction: {
        text: "How to contact my representative?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: "Ameriflex Contacts"
    },
    actions: [
      {
          text: "Finish",
          recommended: true,
          visible: () => true,
          click: async(component, guidanceItem) => {        
            await component.clickCompleteAction(guidanceItem);
            
            let showSurvey = await guidanceUtils.takeSurvey(guidanceItem);

            if(showSurvey == true){
                var url = await guidanceUtils.getImplemnetationSurveyLink(guidanceItem.employerId, guidanceItem.workflowId);
                window.open(url, '_blank').focus();
            }
        }
      },
    ]
})


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-plan-admin-done-cobra.js